/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect, useState, useRef } from "react";
import "./AutoComplete.css";
import CloseIconWhite from "../../../images/error-close-icon.svg";
import Vector from "../../../images/Vector-Orange.svg";
import whiteVector from "../../../images/white_search_icon.svg";
import SearchDropDown from "../../../images/arrow-down.svg";
import CloseIcon from "../../../images/close-Icon-black.svg";
import { useNavigate } from "react-router-dom";
import { getYearFromDate, sortByDate } from "../../../utilities/dateUtilities";
import { useDispatch } from "react-redux";
import * as WorldAction from "@mywvglobal-shared/mywv-shared/action/worldAction";
import { t } from "i18next";
import { encrypt } from "../../../utilities/tokenizer";
import ImageCheck from "../../atoms/ImageCheck";

const AutoCompleteSearch = (props) => {
    const [activeSuggestion, setActiveSuggestion] = useState(0);
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [userInput, setuserInput] = useState("");
    const [suggestions, setSuggestions] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dropdownRef = useRef(null);
    const [selectedChildData, setSelectedChildData] = useState();

    const onChange = (e) => {
        const userInput = e.currentTarget.value;
        const filteredSuggestions = suggestions?.filter(
            suggestion =>
                suggestion[props.searchBy].toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );
        setActiveSuggestion(0);
        setFilteredSuggestions(filteredSuggestions);
        setShowSuggestions(true);
        setuserInput(userInput);
    }

    const closeOpenMenus = (e) => {
        if (dropdownRef.current && showSuggestions && !dropdownRef.current.contains(e.target)) {
            if (e.target?.parentElement?.className !== "inputwrapper inputwrapperorange" && e.target.className !== "inputwrapper inputwrapperorange") {
                setShowSuggestions(false)
                setuserInput("");
            }
        }
    }

    useEffect(() => {
        window.addEventListener("mousedown", closeOpenMenus);
        return () => {
            window.removeEventListener("mousedown", closeOpenMenus);
        }
    })

    useEffect(() => {
        const isiOS = /iPad|iPhone/.test(navigator.userAgent) && !window.MSStream;
        if (isiOS) {
            let startY = 0;
            const onTouchStart = (e) => {
                startY = e.touches[0].clientY;
            };
            const onTouchMove = (e) => {
                const currentY = e.touches[0].clientY;
                const deltaY = startY - currentY;
                startY = currentY;
                const scrollableElement = document.querySelector(".suggestions");
                if (scrollableElement) {
                    scrollableElement.scrollTop += deltaY;
                    e.preventDefault();
                }
            };
            document.addEventListener("touchstart", onTouchStart, { passive: false });
            document.addEventListener("touchmove", onTouchMove, { passive: false });
            return () => {
                document.removeEventListener("touchstart", onTouchStart);
                document.removeEventListener("touchmove", onTouchMove);
            };
        }
    }, []);

    useEffect(() => {
        let suggestionslist = getSearchData(props.suggestions, props?.Give);
        suggestionslist = sortByDate(suggestionslist, "sponsorshipStartDate");
        suggestionslist = sortByDate(suggestionslist, "latestUpdateDate");

        if (props.selectedChild) {
            let index = suggestionslist?.findIndex(item => item.code === props.selectedChild);

            if (index >= 0) {
                var element = suggestionslist[index];
                suggestionslist?.splice(index, 1);
                suggestionslist?.splice(0, 0, element);
                let sortedlist = suggestionslist;
                setSuggestions(sortedlist);
            }
        } else {
            setSuggestions(suggestionslist);
        }

    }, [props.suggestions, props.selectedChild]);

    useEffect(() => {
        if (suggestions) {
            let index = suggestions?.findIndex(item => item.code === props.selectedChild) || 0;
            let selectedValue = suggestions[index]?.name;
            setSelectedChildData(selectedValue);
        }
    }, [props.selectedChild, suggestions]);

    const onClick = (e, suggestions) => {
        setActiveSuggestion(0);
        setFilteredSuggestions([]);
        setShowSuggestions(false);
        handleChildClick(suggestions);
        setuserInput("");
    };

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            setShowSuggestions(false);
            handleChildClick(filteredSuggestions[activeSuggestion])

        } else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }
            setActiveSuggestion(activeSuggestion - 1);
        }
        // User pressed the down arrow, increment the index
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }
            setActiveSuggestion(activeSuggestion + 1);
        }
    };

    const handleChildClick = (selectedchild) => {
        if (props.connectChildChange) {
            const param = {
                selectedChildValues: selectedchild?.data,
            };
            dispatch(WorldAction.saveChildDetails(param));
            navigate(`/connect/${encrypt(selectedchild?.data?.childCode)}`)
        } else {
            const param = {
                selectedChildValues: selectedchild?.data,
            };
            dispatch(WorldAction.saveChildDetails(param));
            navigate(`/communityhomeview/${encrypt(selectedchild?.data?.childCode)}`)
        }
    }

    const suggestionsList = () => {
        let suggestionsListComponent;
        if (showSuggestions) {
            if (filteredSuggestions?.length) {
                suggestionsListComponent = (
                    <div className={props?.worldHeader ? "suggestions suggestionsWorld" : "suggestions suggestionsStation"} ref={dropdownRef}>
                        {filteredSuggestions?.map((suggestion, index) => {
                            let className;
                            // Flag the active suggestion with a class
                            if (index === activeSuggestion) {
                                className = "suggestion-active";
                            }
                            return (
                                <li className={className} key={index} onClick={(e) => onClick(e, suggestion)}>
                                    <div className="child-img-container">
                                        <span className={suggestion?.data?.hasUpdate ? "hasUpdate" : ""}>
                                            <ImageCheck
                                                className={suggestion?.data?.hasUpdate ? "list-child-img-update" : suggestion?.data?.childImageURL ? "list-child-img" : "list-child-img-placeholder"}
                                                imageUrl={suggestion?.data?.childImageURL}
                                                placeholderImage={1}
                                            />
                                        </span>
                                    </div>
                                    <div className="userInputSuggestions">
                                        <span className="textBold">{suggestion.name} </span>
                                        <span className="suggestionsDetails">- {suggestion?.data?.countryName}</span>
                                    </div>
                                </li>
                            );
                        })}
                    </div>
                );
            } else {
                suggestionsListComponent = (
                    <div className={props?.worldHeader ? "suggestions suggestionsWorld" : "suggestions suggestionsStation"} ref={dropdownRef}>
                        <li className="suggestion-active">
                            <span className="textBold">{t("NoResults")}</span>
                        </li>
                    </div>
                );
            }
        }
        return suggestionsListComponent;
    }

    const clearInput = () => {
        setActiveSuggestion(0);
        setFilteredSuggestions([]);
        setShowSuggestions(false);
        setuserInput("");
        if (props?.deSelectChild) {
            props.deSelectChild();
        }
    }

    const openSuggestion = () => {
        let openSuggestion = showSuggestions;
        setActiveSuggestion(0);
        setFilteredSuggestions(suggestions);
        setShowSuggestions(!openSuggestion);
    }

    const handleInputClick = () => {
        openSuggestion()
    }

    return (
        <>
            <div className={props?.worldHeader ? "inputwrapper inputwrapperwhite" : "inputwrapper inputwrapperorange"} onClick={handleInputClick} ref={dropdownRef}>
                <img src={props?.worldHeader ? whiteVector : Vector} alt="searchicon" className="icon" />
                <input
                    type="text"
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    value={userInput}
                    className={`searchInput communityHeader inputmaxWidth ${props?.worldHeader && "worldHeaderSearch"}`}
                    placeholder={props?.worldHeader ? t("SearchName") : selectedChildData}
                />
                {props?.worldHeader ? null : (<img src={SearchDropDown} alt="dropdown" className="dropdown_icon" />)}
                {userInput && userInput.length > 0 ?
                    <img src={props?.worldHeader ? CloseIconWhite : CloseIcon} alt="searchicon" className="closeicon"
                        onClick={clearInput} />
                : ""}
            </div>
            {suggestionsList()}
        </>
    );
}

export default AutoCompleteSearch;

export const getSearchData = (worldData, Give) => {
    let childdata = [];
    worldData?.map(data => {
        if (Give) {
            let startYear = getYearFromDate(data?.sponsorshipStartDate)
            childdata.push({
                "name": data.childFirstName, "community": data.projectName, country: data.countryName, data: data,
                "displayValue": `${data?.childFirstName} - ${t("LabelSince")} ${startYear} | ${data.projectName}, ${data.countryName}`,
                "code": data?.childCode, "latitude": data?.latitude, "longitude": data?.longitude
            })
        } else {
            if (!data.isSponsor) {
                if (data?.childValues?.length > 1) {
                    data.childValues.map(item => {
                        let startYear = getYearFromDate(item?.sponsorshipStartDate)
                        !item?.chosenCorrelationID && childdata.push({
                            "name": item?.childFirstName, "community": data.communityName, country: data.countryName, data: item,
                            "displayValue": `${item?.childFirstName} - ${t("LabelSince")} ${startYear} | ${data.childProjectCountry}`, "code": item?.childCode,
                            "latitude": data.latitude, "longitude": data.longitude
                        })
                    })
                } else if (data?.childValues) {
                    let startYear = getYearFromDate(data?.childValues?.sponsorshipStartDate)
                    !data?.childValues?.chosenCorrelationID && childdata.push({
                        "name": data.childValues?.childFirstName, "community": data.communityName, country: data.countryName, data: data?.childValues,
                        "displayValue": `${data?.childValues?.childFirstName} - ${t("LabelSince")} ${startYear} | ${data.childProjectCountry}`,
                        "code": data?.childValues?.childCode, "latitude": data.latitude, "longitude": data.longitude
                    })
                }
                else {
                    let startYear = getYearFromDate(data?.sponsorshipStartDate)
                    !data?.chosenCorrelationID && childdata.push({
                        "name": data?.childFirstName, "community": data?.community, country: data.countryName, data: data,
                        "displayValue": `${data?.childFirstName} - ${t("LabelSince")} ${startYear} | ${data?.projectName}, ${data?.countryName}`,
                        "code": data?.childCode
                    })
                }
            }
        }
    })
    return (childdata);
};